export enum PacoteStatusEnum {
  NOVO = 1,
  RASCUNHO = 2,
  CADASTRADO = 3,
  ENVIADO_PARA_APROVACAO = 4,
}

export const getPacoteStatusValues = (): (number | string)[] => Object.values(PacoteStatusEnum);
